import { css } from 'lit';

export const sharedFont = css`
  :host {
    --baseline: var(--root-font-size);
  }

  @media (prefers-text-size: large) {
    :host {
      --baseline: var(--root-font-size) * 1.25;
    }
  }

  h1,
  .h1 {
    /**--- Large Header ---*/
    font-size: 4rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-transform: uppercase;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  h2,
  .h2 {
    /**--- Header ---*/
    font-size: 2.8rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  h3,
  .h3 {
    /**--- Small Header, Header of Dialog ---*/
    font-size: calc(var(--baseline) * 2.2);
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  h4,
  .h4 {
    /**--- Tab, Button ---*/
    font-size: calc(var(--baseline) * 1.6);
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-transform: uppercase;
  }

  h5,
  .h5 {
    /**--- Category bar, Separator ---*/
    font-size: calc(var(--baseline) * 1.4);
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-transform: uppercase;
  }

  h6,
  .h6 {
    /**--- Category bar(4 categories) ---*/
    font-size: calc(var(--baseline) * 1.2);
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .subtitle-1 {
    /**--- Primary text ---*/
    font-size: calc(var(--baseline) * 1.8);
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .subtitle-2 {
    /**--- Secondary text ---*/
    font-size: calc(var(--baseline) * 1.4);
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .body-1 {
    /**--- Body text ---*/
    font-size: calc(var(--baseline) * 1.8);
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .body-2 {
    /**--- Small Body text ---*/
    font-size: calc(var(--baseline) * 1.6);
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }
`;
